export const routes = {
	adminDashboard: "dashboard",
	tenantDashboard: "customer-dashboard",
	tenants: "tenant",
	tenantContacts: "tenantContact",
	requests: "request",
	kpi: "kpi",
	configurations: "configurations",
	unAuthorizedAccess: "unAuthorizedAccess",
	notfound: "notfound",
	error: "error",
	aboutUs: "aboutUs",
	tenantLogin: "Login",
	abrfAuth: "AbrfAuth",
	apm: "apm",
	communication: "communication",
	healthAndSafety: "observation",
	reporting:"reporting",
	securityIncident:"securityIncident",
	newGrantAccess:"SDCGrantAccess",
	pendingNotification: "pendingNotifications",
	apiKeyManagement: "apiKeyManagement",
	welcome: "welcome"
};
